import styles from "./dashboardGrid.module.scss";
import sortIcon from "../../assets/images/sort.svg";
import { Link } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { FaSort } from "react-icons/fa";

const DashboardGridView = ({productList, users, updateSorting, activeTab }) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const [sortProp, setSortProp] = useState(null);
  const [sortDirection, setSortDirection] = useState(true);
  const [openReviewerIndex, setOpenReviewerIndex] = useState(null);
  const reviewerPopupRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (reviewerPopupRef.current && !reviewerPopupRef.current.contains(event.target)) {
        setOpenReviewerIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const setSortObjectForProp = (prop) => {
    if (sortProp === prop) {
      setSortDirection(!sortDirection);
    } else {
      setSortDirection(false);
    }
    setSortProp(prop);

    updateSorting(prop, !sortDirection)
  };

  const formatDate = (dateString, includeTime) => {
    const date = new Date(dateString);
    const options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    };

    if(includeTime) {
      options.hour = '2-digit';
      options.minute = '2-digit';
      options.hour12 = true;
    }
    return new Intl.DateTimeFormat('en-US', options).format(date);
}

  const getCreationDateStr = (item) => {
    const creationDate = new Date(item.CreationDate);
    const creationDateStr = `${creationDate.getDate()} ${months[creationDate.getMonth()]}, ${creationDate.getFullYear()}`;
    return creationDateStr;
  }

  const getLastUpdateStr = (item) => {
    const lastUpdate = new Date(item.LastUpdate);
    const lastUpdateStr = `${lastUpdate.getDate()} ${months[lastUpdate.getMonth()]}, ${lastUpdate.getFullYear()}`;
    return lastUpdateStr;
  }
  
  const findNameByEmail = (email) => {
    if(users) {
      const user = users.find(user => user.email === email);
      return user ? user.name : 'Email not found';
    }
  };

  const getStateTooltip = (item) => {
    const { Status, State } = item;

    const TOOLTIP_MAP = {
      draft: {
        DRAFT: "This item is in Draft state. You can continue editing and complete your draft before submitting it for review.",
      },
      incoming: {
        In_Review: "This model has been submitted for your review. Please review and take action to approve or reject it.",
        Pre_Prod: "This model has been approved to Pre-Prod state. It is awaiting your final approval to promote it to CoolCloud production.",
      },
      outgoing: {
        IN_REVIEW: "This model was created by you and is currently under review. It will appear in the reviewer's Incoming tab until a decision is made.",
        "APPROVED_Staging": "This product is created by you and it is under CoolCloud testing.",
        "APPROVED_Pre_Prod": "This model was created by you and has been approved to Pre-Prod state. It is now awaiting the reviewer's final approval to promote it to CoolCloud production.",
      },
      incoolcloudtest: {
        Staging: "This product is currently undergoing CoolCloud testing (Staging). Once the engineer confirms successful validation and requests a production push, the manager can proceed to promote it to production.",
      },
      completed: {
        "APPROVED_Production": "This product has been successfully pushed to both CoolCloud and AMS databases and is now live in Production.",
        REJECTED: "This item was reviewed and rejected. No further action is required unless it is resubmitted as a new draft.",
      },
    };

    const tabMap = TOOLTIP_MAP[activeTab];
    if (!tabMap) return undefined;

    // Check composite key (Status_State) first, then Status, then State
    const compositeKey = `${Status}_${State}`;
    return tabMap[compositeKey] || tabMap[Status] || tabMap[State] || undefined;
  };

  const sortArrayByObject = (productList, sortProp) => productList;

  const formatState = (state) => {
    if (!state) return "-";
    return state.replace(/_/g, " ");
  };

  return (
    <div className={styles.table}>
      <div className={styles.tableContainer}>
        <div style={{ width: "100%" }}>
          <div className={styles.header}>
            <div onClick={() => setSortObjectForProp("ModelNumber")}>
              <span>Model Number</span>
              <FaSort className={styles.icon} />
              {sortProp === 'ModelNumber' && (
                <span className={styles.sortIndicator}>
                  {sortDirection ? '↑' : '↓'}
                </span>
              )}
            </div>
            <div onClick={() => setSortObjectForProp("Family")}>
              <span>Product Family</span>
              <FaSort className={styles.icon} />
              {sortProp === 'Family' && (
                <span className={styles.sortIndicator}>
                  {sortDirection ? '↑' : '↓'}
                </span>
              )}
            </div>
            <div onClick={() => setSortObjectForProp("SubCategory")}>
              <span>Product sub category</span>
              <FaSort className={styles.icon} />
              {sortProp === 'SubCategory' && (
                <span className={styles.sortIndicator}>
                  {sortDirection ? '↑' : '↓'}
                </span>
              )}
            </div>
            <div>{activeTab === "completed" ? "Status" : "State"}</div>
            <div>Created By</div>
            <div>Reviewer</div>
            <div
              onClick={() => setSortObjectForProp("CreationDate")}
            >
              <span>Created On</span>
              <FaSort className={styles.icon} />
              {sortProp === 'CreationDate' && (
                <span className={styles.sortIndicator}>
                  {sortDirection ? '↑' : '↓'}
                </span>
              )}
            </div>
            <div
              onClick={() => setSortObjectForProp("LastUpdate")}
            >
              <span>Last Updated</span>
              <FaSort className={styles.icon} />
              {sortProp === 'LastUpdate' && (
                <span className={styles.sortIndicator}>
                  {sortDirection ? '↑' : '↓'}
                </span>
              )}
            </div>
          </div>
          {sortArrayByObject(productList, []).map((item, idx) => {
            return (
              <div key={JSON.stringify(item)} className={styles.contentRow}>
                {/* <div className={styles.td}><Link to={`/reviewItem?id=${item.id}`}>{item.ModelNumber}</Link></div> */}
                <div className={styles.td}><Link to={activeTab === "draft" ? `/products/create-shared-data?id=${item.ProductId}&actionId=${item.id}` : `/reviewItem?id=${item.id}&tab=${activeTab}`}>{item.ModelNumber}</Link></div>
                <div className={styles.td}>{item.Family}</div>
                <div className={styles.td}>{item.SubCategory}</div>
                <div className={styles.td}>
                  <div
                    className={styles.state}
                    title={getStateTooltip(item)}
                  >
                    {activeTab === "completed" ? item.Status : formatState(item.State)}
                  </div>
                </div>
                <div className={styles.td}>
                  {findNameByEmail(item.CreatedByEmail)}
                </div>
                <div className={styles.td} style={{ position: 'relative' }}>
                  {item.ReviewerEmails && Array.isArray(item.ReviewerEmails) && item.ReviewerEmails.length > 0
                    ? (() => {
                        const names = item.ReviewerEmails.map(findNameByEmail);
                        if (names.length === 1) return names[0];
                        return (
                          <>
                            {names[0]}{' '}
                            <span
                              className={styles.reviewerMore}
                              onClick={e => {
                                e.stopPropagation();
                                setOpenReviewerIndex(openReviewerIndex === idx ? null : idx);
                              }}
                            >
                              +{names.length - 1}
                            </span>
                            {openReviewerIndex === idx && (
                              <div
                                ref={reviewerPopupRef}
                                className={styles.reviewerPopup}
                              >
                                {names.map((n, i) => (
                                  <div key={i} style={{ padding: '2px 0' }}>{n}</div>
                                ))}
                              </div>
                            )}
                          </>
                        );
                      })()
                    : findNameByEmail(item.ReviewerEmail)}
                </div>
                <div className={styles.td} title={formatDate(item.CreationDate, true)}>
                  {/* {getCreationDateStr(item)} */}
                  {formatDate(item.CreationDate)}
                </div>
                <div className={styles.td} title={formatDate(item.LastUpdate, true)}>
                  {/* {getLastUpdateStr(item)} */}
                  {formatDate(item.LastUpdate)}
                </div>
                
              </div>
            );
          })}
        </div>
      </div>
      {/* <TablePagination
        total={totalResults}
        currentPage={currPage}
        onPageChange={onPageChange}
        itemsPerPage={itemsPerPage}
        items={productList}
        onItemsPerPageChange={onItemsPerPageChange}
      /> */}
    </div>
  )
}

export default DashboardGridView;